module.exports = "pegasus/assets/tech/sale/101.png";